import * as React from 'react';
import './Sidebar.scss';
import Header from '../Header/Header';
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb'; // Import Breadcrumb component
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { Drawer } from '@mui/material';
import { AppBar } from '@mui/material';
import { CssBaseline } from '@mui/material';
import { Toolbar } from '@mui/material';
import { List } from '@mui/material';
import { ListItem } from '@mui/material';
import { ListItemButton } from '@mui/material';
import { ListItemIcon } from '@mui/material';
import { ListItemText } from '@mui/material';

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

import Dashboard from '../../Pages/Dashboard/Dashboard';
import Flipkart from '../../Pages/Flipkart/Flipkart';
import Google from '../../Pages/Google/Google';
import Website from '../../Pages/Website/Website';

const DashboardPage = () => <Dashboard />;
const FlipkartPage = () => <Flipkart />;
const GooglePage = () => <Google />;
const WebsitePage = () => <Website />;

const drawerWidth = 240;

function Sidebar() {
    const location = useLocation();
    const routes = [
        { path: '/', name: 'Dashboard', element: <DashboardPage />, exact: true, icon: <DashboardOutlinedIcon /> },
        {
            path: '/flipkart', name: 'Flipkart', element: <FlipkartPage />, icon: <ShoppingCartIcon />, hasSubmenu: true, submenu: [
                { path: '/flipkart/products', name: 'Products', element: <div>Products Page</div> },
                { path: '/flipkart/orders', name: 'Orders', element: <div>Orders Page</div> },
            ]
        },
        { path: '/google', name: 'Google', element: <GooglePage />, icon: <AutoGraphOutlinedIcon /> },
        { path: '/website', name: 'Website', element: <WebsitePage />, icon: <LanguageOutlinedIcon /> },
    ];

    const isSubmenuVisible = (route) => {
        if (!route.hasSubmenu) return false;
        return route.submenu.some(subRoute => location.pathname.startsWith(subRoute.path)) || location.pathname === route.path;
    };

    // Construct breadcrumb items from routes
    const breadcrumbItems = routes.filter(route => location.pathname.startsWith(route.path))
        .map(route => ({ label: route.name, href: route.path }));

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Header />
            </AppBar>

            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                <Toolbar />
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        {routes.map((route, index) => (
                            <React.Fragment key={route.name}>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        component={NavLink}
                                        to={route.path}
                                        sx={{
                                            '&.active': {
                                                backgroundColor: 'rgb(66 93 120 / 54%)',
                                                color: '#fff',
                                                '& .MuiListItemIcon-root': {
                                                    color: '#fff',
                                                },
                                            },
                                            color: '#b0b0b0',
                                        }}
                                    >
                                        <ListItemIcon>
                                            {route.icon}
                                        </ListItemIcon>
                                        <ListItemText primary={route.name} />
                                    </ListItemButton>
                                </ListItem>
                                {isSubmenuVisible(route) && route.submenu.map((subRoute) => (
                                    <ListItem key={subRoute.name} disablePadding sx={{ pl: 4 }}>
                                        <ListItemButton
                                            component={NavLink}
                                            to={subRoute.path}
                                            sx={{
                                                '&.active': {
                                                    backgroundColor: 'rgb(66 93 120 / 54%)',
                                                    color: '#fff',
                                                    '& .MuiListItemIcon-root': {
                                                        color: '#fff',
                                                    },
                                                },
                                                color: '#b0b0b0',
                                            }}
                                        >
                                            <ListItemIcon>
                                                <SubdirectoryArrowRightIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={subRoute.name} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </React.Fragment>
                        ))}
                    </List>
                </Box>
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />
                <Breadcrumb items={breadcrumbItems} /> {/* Pass breadcrumbItems to Breadcrumb component */}
                <Routes>
                    {routes.map((route) => (
                        <Route key={route.name} path={route.path} element={route.element} exact={route.exact} />
                    ))}
                    {routes.filter(route => route.hasSubmenu).flatMap(route =>
                        route.submenu.map(subRoute => (
                            <Route key={subRoute.name} path={subRoute.path} element={subRoute.element} />
                        ))
                    )}
                </Routes>
            </Box>
        </Box>
    );
}

export default function App() {
    return (
        <Router>
            <Sidebar />
        </Router>
    );
}
